import { render } from "./FlashAlerts.vue?vue&type=template&id=4c7ca859"
import script from "./FlashAlerts.vue?vue&type=script&lang=js"
export * from "./FlashAlerts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__